<template>
    <v-card>
        <v-card-title class="headline">{{title}}</v-card-title>
        <v-card-text>
            <v-container fluid>
                <v-row>

                    <v-col cols="12">
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-textarea v-model="reason" label="Powód usunięcia:" rows="3" :rules="[v=> !!v || 'Proszę podać powód usunięcia.']"></v-textarea>
                        </v-form>
                    </v-col>
                </v-row>

            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-btn @click="save()" color="success">Zapisz</v-btn>
            <v-spacer></v-spacer>
            <v-btn @click="closeForm()" color="error">Zamknij</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>


    import {clientService} from "../../services";
    import swal from "sweetalert";

    export default {
        name: "DeleteDisease",
        props: ["editedObject"],
        data() {
            return {
                title: '',
                reason: '',
                valid: true
            }
        },
        methods: {
            save()
            {
                if(this.$refs.form.validate()) {
                    clientService.deleteClientDisease({id: this.editedObject.id, reason: this.reason}).then(() => {
                        this.$emit('close')
                    }).catch(() => {
                        this.showError((false,'Błąd usuwania.'))
                    })
                }
            },
            closeForm() {
                this.$emit('close')
            },
            showError(close, text) {
                swal({
                    title: "Błąd",
                    text: text,
                    icon: "warning",
                    button: "OK"
                }).then(() => {
                    this.loading = false;
                    if (close) {
                        this.$emit("close");
                    }
                });
            },
        },
        watch: {
            editedObject: {
                immediate: true,
                handler(val) {
                    if (val != null) {

                        if (val.type == 1) {
                            this.title = 'Usuwanie alergii'
                        }
                        else
                        {
                            this.title= 'Usuwanie choroby'
                        }

                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>